import { toast as hotToast, ToastOptions } from 'react-hot-toast';

export interface CustomToastOptions extends Omit<ToastOptions, 'icon' | 'style'> {
  duration?: number;
}

class CustomToast {
  success(message: string, options?: CustomToastOptions) {
    return hotToast.success(message, {
      duration: 4000,
      style: {
        background: '#10b981',
        color: '#ffffff',
      },
      ...options,
    });
  }

  error(message: string, options?: CustomToastOptions) {
    return hotToast.error(message, {
      duration: 5000,
      style: {
        background: '#ef4444',
        color: '#ffffff',
      },
      ...options,
    });
  }

  warning(message: string, options?: CustomToastOptions) {
    return hotToast(message, {
      icon: '⚠️',
      duration: 4500,
      style: {
        background: '#fbbf24',
        color: '#92400e',
      },
      ...options,
    });
  }

  info(message: string, options?: CustomToastOptions) {
    return hotToast(message, {
      icon: 'ℹ️',
      duration: 4000,
      style: {
        background: '#3b82f6',
        color: '#ffffff',
      },
      ...options,
    });
  }

  loading(message: string, options?: CustomToastOptions) {
    return hotToast.loading(message, {
      style: {
        background: '#6b7280',
        color: '#ffffff',
      },
      ...options,
    });
  }

  promise<T>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string | ((data: T) => string);
      error: string | ((error: any) => string);
    },
    options?: CustomToastOptions
  ) {
    return hotToast.promise(promise, messages, {
      style: {
        background: '#ffffff',
        color: '#374151',
      },
      ...options,
    });
  }

  dismiss(toastId?: string) {
    return hotToast.dismiss(toastId);
  }

  remove(toastId?: string) {
    return hotToast.remove(toastId);
  }
}

export const toast = new CustomToast();